
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bXFr8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1738c5b880537784$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $1738c5b880537784$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': "Prida\u0165 vlastn\xfd z\xe1bavn\xfd obr\xe1zok",
    'fabric.emoji.add.label': "Prida\u0165 z\xe1bavn\xfd obr\xe1zok",
    'fabric.emoji.cancel.label': "Zru\u0161i\u0165",
    'fabric.emoji.categories.search.results': "V\xfdsledky vyh\u013Ead\xe1vania",
    'fabric.emoji.category.activity': 'Aktivita',
    'fabric.emoji.category.all.uploads': "V\u0161etky nahran\xe9 s\xfabory",
    'fabric.emoji.category.flags': 'Vlajky',
    'fabric.emoji.category.foods': "Jedlo a n\xe1poje",
    'fabric.emoji.category.frequent': "\u010Cast\xe9",
    'fabric.emoji.category.nature': "Pr\xedroda",
    'fabric.emoji.category.objects': 'Predmety',
    'fabric.emoji.category.people': "\u013Dudia",
    'fabric.emoji.category.places': 'Cestovanie a miesta',
    'fabric.emoji.category.productivity': 'Produktivita',
    'fabric.emoji.category.symbols': 'Symboly',
    'fabric.emoji.category.user.uploads': "Va\u0161e nahran\xe9 s\xfabory",
    'fabric.emoji.choose.file.title': "Vybra\u0165 s\xfabor",
    'fabric.emoji.delete.description': "V\u0161etky existuj\xface in\u0161tancie tohto z\xe1bavn\xe9ho obr\xe1zka sa nahradia obr\xe1zkom {emojiShortName}",
    'fabric.emoji.delete.label': "Odstr\xe1ni\u0165",
    'fabric.emoji.delete.title': "Odstr\xe1ni\u0165 z\xe1bavn\xfd obr\xe1zok",
    'fabric.emoji.error.delete.failed': "Odstr\xe1nenie zlyhalo",
    'fabric.emoji.error.image.too.big': "Vybran\xfd obr\xe1zok je v\xe4\u010D\u0161\xed ako 1 MB",
    'fabric.emoji.error.invalid.image': "Vybran\xfd obr\xe1zok je neplatn\xfd",
    'fabric.emoji.error.upload.failed': "Nahr\xe1vanie zlyhalo",
    'fabric.emoji.image.requirements': "JPG, PNG alebo GIF. Max. ve\u013Ekos\u0165 1 MB.",
    'fabric.emoji.name.ariaLabel': "Zadajte n\xe1zov nov\xe9ho emoji",
    'fabric.emoji.placeholder': "N\xe1zov z\xe1bavn\xe9ho obr\xe1zka",
    'fabric.emoji.preview': "V\xe1\u0161 nov\xfd z\xe1bavn\xfd obr\xe1zok {emoji} vyzer\xe1 v\xfdborne",
    'fabric.emoji.preview.title': "Uk\xe1\u017Eka",
    'fabric.emoji.retry.label': "Sk\xfasi\u0165 znova"
};

});


//# sourceMappingURL=sk.de83cb1c.js.map
